import React from "react";

const InfoField = ({ label, value }) => (
  <div className="info-field">
    <span className="info-field_label">{label}</span>
    <span className="info-field_value">{value || "-"}</span>
  </div>
);

const HPInfoView = ({ formData, secondaryEmails }) => {
  return (
    <div className="patient-info-grid">
      <InfoField label="Name" value={formData.name} />
      <InfoField label="User Name" value={formData.userName} />
      <InfoField label="Prefix" value={formData.prefix} />
      <InfoField label="Mobile Number" value={formData.mobileNumber} />
      <InfoField label="Email" value={formData.emailId} />
      <InfoField label="Workplace" value={formData.workPlace} />
      <InfoField label="Position" value={formData.position} />
      <InfoField label="Description" value={formData.description} />
      
      <div className="info-field" style={{ gridColumn: "1 / -1" }}>
        <span className="info-field_label">Assigned Devices</span>
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "8px" }}>
          {Array.isArray(formData.assignDevices) && formData.assignDevices.length > 0 ? (
            formData.assignDevices.map((device) => (
              <span
                key={device.value}
                style={{
                  padding: "6px 12px",
                  backgroundColor: "#f1f5f9",
                  borderRadius: "6px",
                  fontSize: "13px",
                  color: "#334155",
                  borderLeft: "3px solid #104581",
                }}
              >
                {device.label} ({device.slots || 0} slots)
              </span>
            ))
          ) : (
            <span style={{ fontSize: "15px", fontWeight: 500, color: "#0f172a" }}>-</span>
          )}
        </div>
      </div>

      {secondaryEmails && secondaryEmails.length > 0 && (
        <div className="info-field" style={{ gridColumn: "1 / -1" }}>
          <span className="info-field_label">Secondary Emails</span>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "8px" }}>
            {secondaryEmails.map((email) => (
              <span
                key={email}
                style={{
                  padding: "6px 12px",
                  backgroundColor: "#f1f5f9",
                  borderRadius: "6px",
                  fontSize: "13px",
                  color: "#334155",
                  borderLeft: "3px solid #104581",
                }}
              >
                {email}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};


export default HPInfoView;
